import { useState, useRef, MutableRefObject } from 'react'
import { usePdf } from '@mikecousins/react-pdf'

export const usePdfViewer = (url: string) => {
  const [page, setPage] = useState(1)
  const canvasRef = useRef(null) as MutableRefObject<null | HTMLCanvasElement>
  const [, setLoading] = useState(true)

  const triggerReload = () => setLoading(true)

  const onPageRenderSuccess = () => setLoading(false)

  const { pdfDocument } = usePdf({
    canvasRef,
    file: url,
    onPageRenderSuccess,
    page,
  })

  return { pdfDocument, setPage, page, canvasRef, triggerReload }
}
